/**
 * constants.ts — package-wide constants shared between kid app, parent
 * admin, sysadmin, and the backend's TS typings.
 *
 * Anything here must be safe to import from a browser bundle (no node
 * APIs). Values intentionally live in one place so a change to the
 * currency glyph or session TTL flows everywhere automatically.
 *
 * 调用关系：
 *   - `DEFAULT_API_BASE` is the fallback when `VITE_API_BASE` is unset
 *     (frontend/src/api/client.ts, admin/src/api/client.ts,
 *     sysadmin/src/api/sysadmin.ts).
 *   - `SESSION_TOKEN_KEY` / `SESSION_TYPE_KEY` are read/written by
 *     frontend + admin (sysadmin uses its own `sysadmin_token` key to
 *     avoid colliding with a logged-in parent on the same browser).
 *   - `CURRENCY_*` are consumed by `format.formatMoney()`.
 *
 * 关键约束：
 *   - `DEFAULT_API_BASE` must point at the production worker — test
 *     stacks override via VITE_API_BASE at build time.
 */

/** Fallback worker URL when VITE_API_BASE is not provided. Test/dev builds
 *  override via the env var; this default targets the production worker. */
export const DEFAULT_API_BASE = 'https://hamster-api.goodluckfordev.workers.dev';

/** localStorage key where the active bearer token lives (kid + parent
 *  apps only; sysadmin uses its own key so a parent session is never
 *  promoted to sysadmin by accident). */
export const SESSION_TOKEN_KEY = 'xpb_session_token';

/** Hints which type of account owns SESSION_TOKEN_KEY so the kid app
 *  vs. admin shell can route to the right post-login screen. */
export const SESSION_TYPE_KEY = 'xpb_session_type';

/** ISO 4217 default. Project decision: economy is pegged 1:1 to MYR
 *  (see memory: "Economy currency — MYR 1:1"). */
export const CURRENCY_CODE_DEFAULT = 'MYR';
/** Site-wide currency glyph — replaced the old 'RM' string with a
 *  gold-coin emoji so the kid UI reads as "金币". */
export const CURRENCY_SYMBOL_DEFAULT = '💰';

/** Session lifetime in days (~10 years). Long-lived intentionally so a
 *  child never has to re-log-in on the family iPad; parent revokes via
 *  password reset which forces a server-side token rotation. */
export const SESSION_TTL_DAYS = 3650;
/** Magic-code expiry in minutes. Mirrors backend/src/routes/auth.js. */
export const EMAIL_CODE_TTL_MINUTES = 15;
